// extracted by mini-css-extract-plugin
module.exports = {"FooterHelp":"FooterHelp_FooterHelp_1sIeB","icon":"FooterHelp_icon_2DjaE","content":"FooterHelp_content_3wxLT","title":"FooterHelp_title__-X1w"};